import React from 'react';
//
import Thumbnail from 'components/thumbnail';
//
export default ({ thumbnail }) => {
  const width = 4;
  const height = thumbnail.height * (4 / thumbnail.width);

  return <Thumbnail fullsize thumbnail={{ ...thumbnail, height, width }} />;
};
